import React from 'react';
import { ShieldCheck, Award, FileText } from 'lucide-react';
export function Insurance() {
  const cards = [{
    icon: FileText,
    title: 'Insurance Claim Help',
    copy: 'Get help with quote details, claim information and scheduling support.'
  }, {
    icon: ShieldCheck,
    title: 'OEM & OEE Glass Options',
    copy: 'Ask about available glass options based on your vehicle, insurance, availability, preference and budget.'
  }, {
    icon: Award,
    title: 'Lifetime Workmanship Warranty',
    copy: "Auto glass installation is backed by Kosin's lifetime vehicle glass workmanship warranty."
  }];
  return <section className="py-16 md:py-20 px-4 sm:px-6 lg:px-8 bg-slate-50 border-y border-slate-200" data-id="element-959" data-mp="2ck0mffvzl9dr">
      <div className="max-w-7xl mx-auto" data-id="element-960" data-mp="2hilq5pag6b6y">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-961" data-mp="1129923do4f7p">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-slate-900 mb-4 tracking-normal leading-tight" data-id="element-962" data-mp="161lx2rg9zsbv">
            <span className="text-emergencyBrand-red" data-id="element-963" data-mp="316l4qbmne55u">Insurance Help</span>,
            Quality Glass &amp; Warranty Protection
          </h2>
          <p className="text-lg text-slate-600" data-id="element-964" data-mp="2w9l0855g5agu">
            Emergency vehicle glass damage is stressful. Kosin's Glass can help
            coordinate with most insurance companies, provide free auto glass
            estimates and explain your repair or replacement options clearly.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10" data-id="element-965" data-mp="3k3w1npkt4mi4">
          {cards.map((card, i) => <div key={i} className="bg-white rounded-lg p-6 border border-slate-200 shadow-sm text-center" data-id="element-966" data-mp="3f51l6uabba16" data-mpi={i}>
              <div className="w-14 h-14 bg-emergencyBrand-redLight rounded-full flex items-center justify-center mx-auto mb-5" data-id="element-967" data-mp="3oxqhuj17ejcg">
                <card.icon className="w-7 h-7 text-emergencyBrand-red" data-id="element-968" data-mp="6rc70sy8epia" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-969" data-mp="2r23dmxwwb6l">
                {card.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-970" data-mp="9qkqb702fuxl">{card.copy}</p>
            </div>)}
        </div>
        <div className="text-center" data-id="element-971" data-mp="jqv4attxd6dt">
          <a href="tel:517-545-7772" className="inline-flex items-center justify-center gap-2 bg-white hover:bg-slate-50 text-slate-900 border border-slate-300 px-7 py-4 rounded-lg font-bold text-base transition-colors" data-id="element-972" data-mp="jptsgn534fv1">
            Ask About Insurance Help
          </a>
        </div>
      </div>
    </section>;
}